export const findFirstAlphaCharacter = (str: string) => {
  try {
    return str ? str.match(/[a-zA-Z]/).pop() : '';
  } catch (e) {}

  return '-';
};
